<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="项目单位：" prop="grade">
                <el-input :value="pnames[0]" disabled></el-input>
            </el-form-item>
            <el-form-item label="单位工程：" prop="grade" v-if="grade>=3">
                <el-input :value="pnames[1]" disabled></el-input>
            </el-form-item>
            <el-form-item label="分部工程：" prop="grade" v-if="grade>=4">
                <el-input :value="pnames[2]" disabled></el-input>
            </el-form-item>
            <el-form-item label="单位工程：" prop="name" v-if="grade==2">
                <el-input v-model="model.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="分部工程：" prop="name" v-if="grade==3">
                <el-input v-model="model.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="单元工程：" prop="name" v-if="grade==4">
                <el-input v-model="model.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="编号：" prop="code">
                <el-input v-model="model.code" disabled></el-input>
            </el-form-item>
            <el-form-item label="简称：" prop="alias">
                <el-input v-model="model.alias" disabled></el-input>
            </el-form-item>
            <el-form-item label="灌浆类型：" prop="grout_type">
                <el-select clearable v-model="model.grout_type" placeholder="请选择" disabled style="width: 200px">
                    <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="计划长度：" prop="plan_length">
                <el-input v-model.number="model.plan_length" :disabled="model.grout_type=='3'" style="width: 200px"></el-input>（M）
            </el-form-item>
            <el-form-item label="计划平米" prop="plan_m2">
                <el-input v-model.number="model.plan_m2" style="width: 200px"></el-input>（m²）
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getProjectDivisionParentNames } from '@/api/org'

export default {
    name: 'projectDivisionPlanSet',
    mixins: [editutil],
    data() {
        return {
            model: {
                code: '',
                name: '',
                alias: '',
                remark: '',
                order_index: '',
                grout_type: '1',
                grade: '',
                pid: '',
                pname: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
                plan_length: '',
                plan_volueme: '',
            },
            getObj:{
                url:'/api/admin/projectdivision/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['grout_type'],
            rules: {
                plan_length: [
                    {required: true, message: '计划长度不能为空', trigger: 'blur'},
                    {type: 'number', message: '计划长度必须是数字值', trigger: 'blur'}
                ],
                plan_m2: [
                    {required: true, message: '计划平米不能为空', trigger: 'blur'},
                    {type: 'number', message: '计划平米必须是数字值', trigger: 'blur'}
                ],
            },
            pnames: [],
            grade: 4,
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/projectdivision/savePlan'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.grout_type = this.model.grout_type+""
            getProjectDivisionParentNames(this.model.pid).then(res=>{
                if(res.code ==1){
                    this.pnames = res.data
                }
            })
        },
    }
};
</script>